<template>
  <router-view/>
  <Loading />
  <Toast />
</template>

<script setup>
import { useStore } from 'vuex'
import { supportedLangs } from '@/config/lang'
import { useRouter } from 'vue-router'
import Loading from '@/components/Loading/index.vue'
import { useI18n } from 'vue-i18n'

const store = useStore()
const router = useRouter()
const { locale: i18nLocale } = useI18n()

router.beforeEach((to, from, next) => {
  const path = to.path
  const routeLocale = to.params.locale
  if (path !== '/404' && !supportedLangs.includes(routeLocale)) {
    next({ path: '/404' })
    return
  }
  if (i18nLocale.value !== routeLocale) {
    i18nLocale.value = routeLocale
    console.log(i18nLocale.value, 'i18nLocale.value')
    store.commit('SET_LOCALE', routeLocale)
  }
  next()
})

</script>

<style lang="less">

</style>
